import { IconContent } from '@icons';

export const arrowRight: IconContent = {
    sm: '<path d="m13.5 8-4.293 4.293-.707-.707L11.586 8.5H2v-1h9.586L8.5 4.414l.707-.707L13.5 8Z" />',
};
